<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showPendientes"
      scrollable
      no-close-on-backdrop
      title="ACTUALIZAR SANCIONES PENDIENTES"
      size="lg"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
    >
      <div
        style="font-weight: bolder;font-size:11px;background:yellow; padding:4px;margin-bottom:10px"
      >
        Los siguientes son jugadores que fueron sancionados con mas partidos de
        los establecidos en el fixture en cierta etapa<br />
        Ejemplo<br />
        Total fechas etapa 2 = 15 fechas;<br />
        Sancionado= 20 partidos, es decir queda pendiente 5 partidos para la
        etapa 3
      </div>
      <div v-for="item in listPendientes" :key="item.id">
        <div
          v-if="item.pendientes.length != 0"
          style="background:#eeeaea; padding:5px"
        >
          <h4>{{ item.categoria }}</h4>
        </div>
        <div
          v-for="pendiente in item.pendientes"
          :key="pendiente.id_sancion_pendiente"
          style="border-bottom:1px solid #cecece;padding:10px"
        >
          <item-sancion-pop-up
            :pendiente="pendiente"
            @sancionExitoPop="quitarDeListaPopUp()"
          ></item-sancion-pop-up>
          <!-- <b-col md="4">
            <b-media vertical-align="center">
              <template #aside>
                <div style="display:grid">
                  <b-avatar
                    size="62"
                    :src="pendiente.foto_jug"
                    :text="avatarText(pendiente.nombres)"
                  />
                  <small
                    style="text-align:center;font-size:16px;font-weight: bolder"
                    ># {{ pendiente.num_camiseta }}
                  </small>
                </div>
              </template>
              <span class="font-weight-bold d-block text-nowrap">
                {{ pendiente.apellido }}
                {{ pendiente.nombre }}
              </span>
              <div class="text-muted small">{{ pendiente.ci_pasaporte }}</div>
              <small class="text-muted">{{ pendiente.categoria }}</small>
              <div class="text-muted text-uppercase small" style="">
                {{ pendiente.equipo }}
              </div>
            </b-media>
          </b-col>
          <b-col md="4">
            <b-media vertical-align="center">
              <span
                class="font-weight-bold d-block text-nowrap"
                style="font-size:12px"
              >
                {{ pendiente.motPrincipal }} en
              </span>
              <div class="text-muted small" style="">
                Etapa {{ pendiente.etapa }} - Fecha {{ pendiente.num_fecha }}
              </div>
              <div class="text-muted small" style="">
                {{ pendiente.local }} vs {{ pendiente.visita }}
              </div>
              <div class="text-muted small" style="">
                jugado el {{ pendiente.fecha_par }}
              </div>
            </b-media>
          </b-col>
          <b-col md="4">
            <b-media vertical-align="center">
              <div class="font-weight-bold d-block" style="font-size:12px">
                Quedan {{ pendiente.duracion }} partidos pendientes de un total
                de
                {{ pendiente.duracion_sancion }}
              </div>
              <div class="text-muted small" style="">
                buscar actualización en Etapa {{ pendiente.etapa_buscar }}
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                style="float:right"
                size="sm"
              >
                Actualizar
              </b-button>
            </b-media>
          </b-col> -->
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <template> </template>
            </b-col>
          </b-row>
        </div>
      </template>
      <!-- <b-button ref="hola" @click="holaMundo">
        aplasta
      </b-button> -->
    </b-modal>
    <!-- </validation-observer> -->
  </div>
</template>
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required, email } from '@validations'
// import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import {
//   // watch,
//   // watchEffect,
//   computed,
//   // reactive,
//   ref,
//   reactive,
//   // onUpdated,
// } from '@vue/composition-api'

// import Cleave from 'vue-cleave-component'
import {
  BModal,
  BRow,
  BCol,
  // BFormInput,
  // BFormTextarea,
  // BButton,
  VBPopover,
  // BAvatar,
  // BMedia,
  // VBTooltip,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'
// import apiCall from '../../utils/apiCall'
import { avatarText } from '@core/utils/filter'
import ItemSancionPopUp from './ItemSancionPopUp.vue'

// import {
//   URL,
//   USER,
//   ROLES,
//   ESTADO_JUGADOR,
//   INSERT_DATA_PLAYER,
//   // INSERT_DATA_HISTORY_PLAYER,
//   UPDATE_DATA_PLAYER,
// } from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // BAvatar,
    // BMedia,
    // vSelect,
    // BFormInput,
    // BFormTextarea,
    // vSelect,
    // ValidationProvider,
    // ValidationObserver,
    // Cleave,
    // BButton,
    ItemSancionPopUp,
    // BForm,
    // BInputGroup,
    // BInputGroupPrepend,
  },
  directives: {
    'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },
  props: {
    listPendientes: Array,
  },

  setup(props, { emit }) {
    // console.log('setup modal')
    // console.log(props.isAbierto)

    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', playerSelected.id_equipo)
      // listPlayers.value = []
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
    }
    function quitarDeListaPopUp() {
      emit('recargaPopPendientes', props.listPendientes)
    }

    return {
      onlyClose,
      resetModal,
      avatarText,
      quitarDeListaPopUp,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.inscrito {
  margin: 0px;
  background: #e6e5e2;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.calificado {
  margin-top: 10px;
  background: #84ef96;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
</style>
